module.exports = __webpack_public_path__ + "static/media/1-7.dac48558.svg";